module.exports = __webpack_public_path__ + "img/front buttons quantity.e2a9f60a.png";